var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCitiesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 6V12H36V54H12V27H15V24H18V27H21V12H27V6H30ZM39 15L48 24V54H39V15ZM33 15H24V27H30V51H33V15ZM27 48H15V51H27V48ZM45 48H42V51H45V48ZM27 42H15V45H27V42ZM45 42H42V45H45V42ZM27 36H15V39H27V36ZM45 36H42V39H45V36ZM27 30H15V33H27V30ZM45 30H42V33H45V30ZM42 22.2426V27H45V25.2426L42 22.2426Z",
    fill: "#1B0076"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitiesIcon);
export default __webpack_public_path__ + "static/media/CitiesIcon.a59a1c34.svg";
export { ForwardRef as ReactComponent };